import * as reactQuery from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { ApiResult } from "../../../../types/ApiResult";

export const useSaveCountertopUniversityQuizAnswer = (
	countertopUniversityQuizID: number,
	answer: string,
	profileID: number | null,
	isCorrect: boolean,
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = reactQuery.useMutation({
		mutationFn: async () => {
			return await apiClient.post("countertop-university/save-answer", {
				countertopUniversityQuizID: countertopUniversityQuizID,
				answer: answer,
				profileID: profileID,
				isCorrect: isCorrect
			}) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when saving the quiz answer: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
